module.exports = __webpack_public_path__ + "static/banner-8-fast-track-8b637528988b3c2c23ce2daf6831019a.jpg";